import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import SignupPage from "./Pages/SignupPage";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import VitrinePage from "./Pages/VitrinePage";
import MeusMateriaisPage from "./Pages/MeusMateriaisPage";
import MateriaisGratuitosPage from "./Pages/MateriaisGratuitosPage";
import NotificacoesPage from "./Pages/NotificacoesPage";
import SuportePage from "./Pages/SuportePage";
import PerfilPage from "./Pages/PerfilPage";
import ManagerPage from "./Pages/ManagerPage";
import MaterialPage from "./Pages/MaterialPage";

const App: React.FC = () => {
  return (
    <div style={{ backgroundColor: "#141414", minHeight: "100vh" }}>
      <Router>
        <Routes>
          <Route path="/" element={<VitrinePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/meus-materiais" element={<MeusMateriaisPage />} />
          <Route path="/materiais-gratuitos" element={<MateriaisGratuitosPage />}/>
          <Route path="/notificacoes" element={<NotificacoesPage />} />
          <Route path="/suporte" element={<SuportePage />} />
          <Route path="/perfil" element={<PerfilPage />} />
          <Route path="/manager" element={<ManagerPage />} />
          <Route path="/material/:materialId" element={<MaterialPage />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
